import {FACTIONS} from "../../../constants/factions";

export const RATMEN_QUOTES = [{
  quote: 'Эльфийка рожает одного сына за 10 лет. Человеческая женщина - за год. А я - по отряду за месяц. Ещё вопросы?',
  author: 'Мать-Щель, старейшая мать выводковых пещер крысолюдов',
  factionId: FACTIONS.RATMEN
}, {
  quote: 'Большая группа — это не тактика. Это природа. Стая всегда права',
  author: 'Визг Шевелящийся, командир Тьмы крысолюдов',
  factionId: FACTIONS.RATMEN
}, {
  quote: 'Ха! Вы считаете потери!',
  author: 'Плодовитый Мат, крысолюд-демограф',
  factionId: FACTIONS.RATMEN
}, {
  quote: 'Драться поодиночке. Зачем?',
  author: 'Рваное Ухо, крысолюд-вожак Соединенных нор и Свалки Трех мостов',
  factionId: FACTIONS.RATMEN
}, {
  quote: 'Поодиночке мы ничтожество. Сотней — проблема. Тысячей — нашествие. Миллионом — конец. А миллионов у нас много',
  author: 'Толстый Брюх, крысолюд-стратег тотального роения Пересохших канав',
  factionId: FACTIONS.RATMEN
}, {
  quote: 'Наша тактика — это когда враг устаёт убивать раньше, чем ты устаёшь умирать',
  author: 'Усталый Клык, крысолюд-ветеран, переживший сотню боёв',
  factionId: FACTIONS.RATMEN
}]